import api from '../../../api/clinique/_accueil'

// KPI-001 : chaque appel demande une capacité courte à be_config puis appelle la Clinique ; le jeton n'est jamais conservé.
const avec_acces = action => new Promise((resolve, reject) => {
    api.access().then((acces) => {
        action(acces.access_token, acces).then(resolve, reject)
    }, reject)
})

export default {
    // KPI-001 : totaux des consultations démarrées (jour, mois Y-m) et en attente, tout le centre
    getStatistiques(data) {
        return avec_acces(token => api.statistiques(data || {}, token))
    },
    // KPI-001 : liste paginée d'un scope (waiting, started_today, started_month)
    getTableau(data) {
        return avec_acces(token => api.liste(data, token))
    }
}
